<script setup>
import StatusIcon from '@/Pages/Common/StatusIcon.vue';
import ActionType from '@/Common/Enum/ActionType.js';
import ContactUsForAssistance from '@/Pages/DomainScore/Partials/ContactUsForAssistance.vue';

defineProps({
  providers: Array
});
</script>

<template>
  <div class="flex flex-col gap-1 md:flex-row md:gap-8">
    <div class="w-1/3 font-bold">
      {{ $t('domain_analysis.partials.providers.providers') }}
    </div>
    <div v-if="!providers.length" class="flex items-center">
      <StatusIcon :action-type="ActionType.INFO" class="mr-2" />
      <ContactUsForAssistance />
    </div>
    <div v-else>{{ providers.join(', ') }}</div>
  </div>
</template>
